module.exports = __webpack_public_path__ + "img/17_89.1ed72a5c.png";